import { useState, useRef } from 'react';
import useElementDims from './useElementDims';

function getLineEquation(x1, y1, x2, y2) {
  if (x1 === x2) {
    // Vertical line: slope is undefined
    return `x = ${x1}`;
  }

  const m = (y2 - y1) / (x2 - x1);
  const b = y1 - m * x1;

  return [m, b];
}

function solveForX(m, b, y) {
  if (m === 0) {
    return null;
  }
  
  return (y - b) / m;
}

function getMaxPointUnderLine(m, b, xMax, yMax) {
  if (m <= 0) {
    throw new Error("Slope m must be greater than 0.");
  }

  const xLimit = (yMax - b) / m;
  const x = Math.min(xMax, xLimit);
  //const y = m * x + b;

  return x;
}



export default function NewScaleToFit({ dimensions, computeChildren }) {
  const [maxW, maxH] = dimensions ?? [];
  const layoutRef = useRef(null);
  const layoutRef2 = useRef(null);
  const layoutDims = useElementDims(layoutRef);
  const layoutDims2 = useElementDims(layoutRef2);
  const [x1, x2] = [300, 400];
  let width = null;
  let scaleFactor = 1;
  if (layoutDims != null && layoutDims2 != null && maxH != null) {
    const [y1, y2] = [layoutDims.height, layoutDims2.height];
    console.log('x1y1x2y2', x1, y1, x2, y2);
    const [m, b] = getLineEquation(x1, y1, x2, y2);
    if (m > 0) {
      // Give it a ~40px allowance
      width = getMaxPointUnderLine(m, b, maxW, maxH - 40);
      console.log('$predHeight', width, '->', width * m + b);
    }
  }
  console.log('$width', width);

  let commonStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  };

  return <div style={{
    border:'3px solid cyan',
  }}>
    <div style={{
      position: 'fixed',
      top: 0, 
      left: 0,
      overflow: 'visible',
      visibility: 'hidden',
    }} ref={layoutRef} className="new-scale-to-fit-layout">
      {computeChildren(x1)}
    </div>
    <div style={{
      position: 'fixed',
      top: 0, 
      left: 0,
      overflow: 'visible',
      visibility: 'hidden',
    }} ref={layoutRef2} className="new-scale-to-fit-layout">
      {computeChildren(x2)}
    </div>
    <div style={{...commonStyle,border:'3px solid lime'}}>
      {computeChildren(width)}
    </div>
  </div>
}
